<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre3">Dramatis Personae</h3>
<p class="calibre1"><span class="speaker">Bischof Konrad von Würzburg</span></p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>, Hofmeister
des Bischofs</p>
<p class="calibre1"><span class="speaker">Markgraf Friedrich</span>, Oberster
Hauptmann der Besatzung von »Unserer Frauen Berg«</p>
<p class="calibre1"><span class="speaker">Hans von Lichtenstein</span>, Domherr</p>
<p class="calibre1">Ritter:<br class="calibre2"/>
<span class="speaker">Heinz von Stein</span><br class="calibre2"/>
<span class="speaker">Wolf von Hanstein</span><br class="calibre2"/>
<span class="speaker">Hans von Grumbach</span><br class="calibre2"/>
<span class="speaker">Sebastian von Geyer</span><br class="calibre2"/>
<span class="speaker">Wolf von Kastell</span><br class="calibre2"/>
<span class="speaker">Lorenz von Hutten</span><br class="calibre2"/>
<span class="speaker">Kunz von der Mühlen</span></p>
<p class="calibre1"><span class="speaker">Gilgenessig</span>, Schreiber</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span></p>
<p class="calibre1"><span class="speaker">Stephan von Menzingen</span></p>
<p class="calibre1"><span class="speaker">Götz von Berlichingen</span></p>
<p class="calibre1"><span class="speaker">Thomas von Hartheim</span></p>
<p class="calibre1"><span class="speaker">Georg von Wertheim</span></p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span></p>
<p class="calibre1"><span class="speaker">Anna von Grumbach</span>, seine Frau</p>
<p class="calibre1"><span class="speaker">Tellermann</span>, Feldhauptmann des
Florian Geyer</p>
<p class="calibre1"><span class="speaker">Karlstatt</span></p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span></p>
<p class="calibre1"><span class="speaker">Der Schultheiß Bezold von
Ochsenfurt</span></p>
<p class="calibre1"><span class="speaker">Lorenz Löffelholz</span>, Feldschreiber
des Florian Geyer</p>
<p class="calibre1"><span class="speaker">Martin</span>, ein fahrender Schüler</p>
<p class="calibre1">Boten:<br class="calibre2"/>
<span class="speaker">Finkenmäuslin</span><br class="calibre2"/>
<span class="speaker">Kunzlin</span></p>
<p class="calibre1"><span class="speaker">Sartorius</span></p>
<p class="calibre1"><span class="speaker">Bermetter</span>, genannt <span class="speaker">Link</span>, ein Würzburger</p>
<p class="calibre1">Bauernführer:<br class="calibre2"/>
<span class="speaker">Jacob Kohl</span><br class="calibre2"/>
<span class="speaker">Pfarrer Bubenleben</span><br class="calibre2"/>
<span class="speaker">Wendel Hippler</span><br class="calibre2"/>
<span class="speaker">Georg Metzler</span><br class="calibre2"/>
<span class="speaker">Flammenbecker</span><br class="calibre2"/>
<span class="speaker">Kratzer</span>, Wirt</p>
<p class="calibre1"><span class="speaker">Erster Bauernhauptmann</span></p>
<p class="calibre1"><span class="speaker">Zweiter Bauernhauptmann</span></p>
<p class="calibre1"><span class="speaker">Dritter Bauernhauptmann</span></p>
<p class="calibre1"><span class="speaker">Schäferhans</span> <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page4" title="lac/MEsswein"></a></p>
<p class="calibre1"><span class="speaker">Marei</span>, Lagerdirne</p>
<p class="calibre1"><span class="speaker">Ein Trunkener</span></p>
<p class="calibre1"><span class="speaker">Ein Dudelsackpfeifer</span></p>
<p class="calibre1"><span class="speaker">Jörg Kumpf</span></p>
<p class="calibre1">Bürger von Rothenburg:<br class="calibre2"/>
<span class="speaker">Kilian</span>, der Harnischweber<br class="calibre2"/>
<span class="speaker">Jos Frankenheim</span>, Schulmeister<br class="calibre2"/>
<span class="speaker">Oswald Barchart</span><br class="calibre2"/>
<span class="speaker">Ochsenhans</span><br class="calibre2"/>
<span class="speaker">Markart Töppelin</span>, genannt
Bohnlein<br class="calibre2"/>
<span class="speaker">Engelhart Goppolt</span>, Leinenweber<br class="calibre2"/>
<span class="speaker">Hans Kunrat</span><br class="calibre2"/>
<span class="speaker">Hans Beheim</span>, Maurer<br class="calibre2"/>
<span class="speaker">Christheinz</span></p>
<p class="calibre1"><span class="speaker">Weitere Bürger von Rothenburg</span></p>
<p class="calibre1"><span class="speaker">Entlaufener Mönch</span></p>
<p class="calibre1"><span class="speaker">Hausierer</span></p>
<p class="calibre1"><span class="speaker">Jöslein</span>, ein alter Jude</p>
<p class="calibre1"><span class="speaker">Eine alte Frau</span></p>
<p class="calibre1"><span class="speaker">Ein zerlumpter Mensch</span>, ihr Sohn</p>
<p class="calibre1"><span class="speaker">Kläuslin</span>, fahrender Musikant</p>
<p class="calibre1"><span class="speaker">Sein Weib</span></p>
<p class="calibre1"><span class="speaker">Sebastian Schertlin</span></p>
<p class="calibre1"><span class="speaker">Feistle</span></p>
<p class="calibre1"><span class="speaker">Ursel</span>, Beschließerin in Grumbachs
Schloß</p>
<p class="calibre1"><span class="speaker">Peter</span>, ein Reitknecht</p>
<p class="calibre1"><span class="speaker">Ein Weinsberger</span></p>
<p class="calibre1"><span class="speaker">Der blinde Mönch</span></p>
<p class="calibre1"><span class="speaker">Ein Höriger</span></p>
<p class="calibre1"><span class="speaker">Ein Bauer</span></p>
<p class="calibre1"><span class="speaker">Die Kellnerin</span></p>
<p class="calibre1"><span class="speaker">Erster Reisiger</span></p>
<p class="calibre1"><span class="speaker">Zweiter Reisiger</span></p>
<p class="calibre1"><span class="speaker">Bauern</span></p>
<p class="calibre1"><span class="speaker">Eine Bäuerin</span></p>
<p class="calibre1"><span class="speaker">Ritter</span></p>
<p class="calibre1"><span class="speaker">Erster Ritter</span></p>
<p class="calibre1"><span class="speaker">Zweiter Ritter</span></p>
<p class="calibre1"><span class="speaker">Erster Domherr</span></p>
<p class="calibre1"><span class="speaker">Domherr</span></p>
<p class="calibre1"><span class="speaker">Trabant</span></p>
<p class="calibre1"><span class="speaker">Gefolge des Bischofs, Ritter, Trabanten,
Bauern, Musikanten, Volk.</span> <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page5" title="lac/MEsswein"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?237debc0